exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".link-list[data-v-7d711626]{padding:5px 0}.link-list a[data-v-7d711626]{display:inline-block;margin:0 5px 5px 0;text-decoration:none;border-radius:5px;background:#ccc;padding:5px 10px}.link-list a.needs-invitation[data-v-7d711626]{background:#dd0}", ""]);

